import type { TypographyToken } from '@elfsight/widget-ui';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { StripeIntegrationSettings } from '../../common';
import { CLASS_COMPONENT } from '../../common';

export function CancellationPolicyText({
  textToken = 'text15'
}: {
  textToken?: TypographyToken;
}) {
  const {
    integrationStripe: { cancellationPolicyText }
  } = useSettings<StripeIntegrationSettings>();

  return (
    <Typography
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'cancellation-policy-text'
      })}
      textToken={textToken}
      textAlign={'left'}
      dangerouslySetInnerHTML={{ __html: cancellationPolicyText }}
    />
  );
}
